import instanceAxios from "./intanceAxios";



export const metricsService = {
    getOtByAssetLocationAndStatus: async (params) => await instanceAxios.get('/otask/metrics/', { params }),
    getTasksByTechnician: async (params) => await instanceAxios.get('/otask/metrics-technician/', { params }),
    getOtMetricsByLocation: async () => await instanceAxios.get('/otask/metrics-location/'),
    getRootLocations: async () => await instanceAxios.get('/otask/root-locations/'),
    getTasksScheduledPerMonth: async (month) => await instanceAxios.get('/otask/metrics-tasks-scheduled-executed-per-month/', { params: month }),
    getTasksNotScheduledPerMonth: async (month) => await instanceAxios.get('/otask/metrics-tasks-not-scheduled-executed-per-month/', { params: month }),
    getOtsWithTasksScheduledByStatus: async () => await instanceAxios.get('/otask/metrics-ots-with-tasks-scheduled-by-status/')
}